Map = {
    data : [{map:[]},{info:[]},{marker:[]}],
    currentfind : [],
    init : function(){
        var mapContainer = $('#map');
        if(mapContainer.data('map')) {
            var info = mapContainer.data('info');
            Map.api = mapContainer.data('api');
            Map.id = 'map';
            Map.icon = mapContainer.data('mark');
            Map.label = mapContainer.data('label') == true ? mapContainer.data('label') : "";
            Map.zoom = mapContainer.data('zoom');
            Map.address = mapContainer.data('address');
            Map.run();
            if (info) {
                Map.info = [];
                var data = Map.address;
                for (var i in data) {
                    Map.info.push({
                        image: data[i].image ? data[i].image : "",
                        name: data[i].name ? data[i].name : "",
                        street: data[i].street ? data[i].street : "",
                        phone: data[i].telephone ? data[i].telephone : ""
                    });
                }
                Map.mapInfo(Map.info);
            }
        }
    },
    run : function(){
        if(typeof Map.api != 'undefined' && typeof Map.id != 'undefined' && typeof Map.address != 'undefined'){
            Map.initMapData();
        }
    },
    initMapData : function(){
        var map = new google.maps.Map(document.getElementById(Map.id), {
            zoom: Map.zoom,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        });
        var geocoder = new google.maps.Geocoder();
        var geos = [];
        var address = Map.address;
        var i = 0;
        var terval = setInterval(function(){
            if(address[i]){
                geocoder.geocode({address: address[i].street}, function(results, status) {
                    if (status === 'OK') {
                        var lat = results[0].geometry.location.lat();
                        var lng = results[0].geometry.location.lng();
                        geos.push({lat:lat,lng:lng});
                    } else {
                        console.log('Element '+i+' Geocode was not successful for the following reason: ' + status);
                    }
                });
                i++;
            }else{
                clearInterval(terval);
                var geo = setInterval(function(){
                    if(geos.length){
                        clearInterval(geo);
                        Map.buildMap(geos,map);
                    }
                },300);
            }
        },300);
    },
    buildMap : function(geos,map){
        var info = new google.maps.InfoWindow();
        if(geos.length > 0) {
            map.setCenter({lat: geos[0].lat , lng: geos[geos.length - 1].lng});
            $.each(geos, function (i, geo) {
                var marker = new google.maps.Marker({
                    position: geo,
                    icon: Map.icon ? "" + Map.icon + "" : "",
                    map: map,
                    label: Map.label != '' ? {text: "" + (parseInt(i) + 1) + "", color: "white"} : ''
                });
                Map.data[2].marker.push(marker);
            })
            Map.data[0].map = map;
            Map.data[1].info = info;
        }
    },
    mapInfo : function(infor){
        var interval = setInterval(function(){
            if(Map.data[2].marker.length > 0){
                clearInterval(interval);
                Map.showinfo(Map.data[0].map,Map.data[1].info,Map.data[2].marker,infor);
            }
        },1000);
    },
    showinfo : function (map,inw,marker,info){
        $('.show-shop').on('click',function(){
            $('.show-shop').removeClass('active');
            $(this).addClass('active');
            var i = parseInt($(this).data('index'));
            var html = '<div class="content-info-address a-clearfix"> <div class="info-image"><img class="img-responsive" src='+info[i].image+' /></div> <div class="info-text"><p class="info-text-name">'+info[i].name+'</p><p class="info-text-street">'+info[i].street+'</p><p class="info-text-phone">'+info[i].phone+'</p></div></div>';
            inw.setContent(html);
            inw.open(map,marker[i]);
        });

        for(var i = 0 ; i < marker.length ; i++){
            marker[i].addListener( 'click', (function(marker, i) {
                return function() {
                    var html = '<div class="content-info-address"><div class="info-image"><img class="img-responsive" src='+info[i].image+' /></div><div class="info-text"><p class="info-text-name">'+info[i].name+'</p><p class="info-text-street">'+info[i].street+'</p><p class="info-text-phone">'+info[i].phone+'</p></div></div>';
                    inw.setContent(html);
                    inw.open(map,marker);
                }
            })(marker[i], i));
        }
        $(document).on('keyup',function(e){
            e.preventDefault();
            if(e.key === "Enter") {
                var city = $('#city-or-state').val();
                Map.search(map,city,inw);
            }
        })
        $(document).on('click','.btn-search',function(e){
            e.preventDefault();
            var city = $('#city-or-state').val();
            Map.search(map,city,inw);
        });
    },
    search : function(map,city,inw){
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({'address': city}, function (results, status) {
            if (status === 'OK') {
                map.setCenter(results[0].geometry.location);
                if (Map.currentfind.length > 0) {
                    Map.currentfind[0].setMap(null);
                    Map.currentfind = [];
                }
                var nmarker = new google.maps.Marker({
                    map: map,
                    position: results[0].geometry.location
                });
                inw.setContent(city.toUpperCase());
                inw.open(map,nmarker);
                Map.currentfind.push(nmarker);
            } else {
                alert('Geocode was not successful for the following reason: ' + status);
            }
        });
    }
}
Map.init();